import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AppService } from 'src/app/core/services/app.service';
import { UserService } from 'src/app/core/services/user.service';
import { OOVenueService } from 'src/app/core/services/venue-service';
import { CCProcessors } from 'src/app/shared/models/enums/CCProcessors.enum';

@Component({
	selector: 'app-payment-processor-setup',
	templateUrl: './payment-processor-setup.component.html',
	styleUrls: ['../../../commandcenter.scss'],
})
export class PaymentProcessorSetupComponent implements OnInit {
	@Input() changesToSave: boolean;
	@Output() changesToSaveChange = new EventEmitter<boolean>();

	cardSecurityOptions = [
		{ label: 'Allow CVV Mismatch / Allow AVS Mismatch', value: 0 },
		{ label: 'Require CVV / Allow AVS Mismatch', value: 1 },
		{ label: 'Require CVV / Require AVS', value: 2 },
	];
	ccProcessors = [
		{ value: 0, label: 'None' },
		{ value: 1, label: 'Shift4' },
		{ value: 2, label: 'AuthNet' },
		{
			label: 'Datacap PayAPI',
			value: 5,
		},
	];

	constructor(public app: AppService, public venueService: OOVenueService, private userService: UserService) {}

	ngOnInit(): void {}

	validateProcessor() {
		if (this.venueService.subscriptionVenue.value.key === 7166) {
			switch (this.venueService.ooVenue.ccProcessor) {
				case CCProcessors.AUTHNET: {
					this.venueService.ooVenue.ccProcessorApiKey = 'authNetApiKey here';
					this.venueService.ooVenue.ccProcessorApiSecret = 'authNetApiSecret here';
					break;
				}
				case CCProcessors.SHIFT4: {
					this.venueService.ooVenue.ccProcessorApiKey = 'B9D463FC-2757-4085-AFBA-2C2A5B6D849A';
					this.venueService.ooVenue.ccProcessorApiSecret = 'B9D463FC-2757-4085-AFBA-2C2A5B6D849A';
					break;
				}
				case CCProcessors.FOCUSPAYDATACAP: {
					this.venueService.ooVenue.ccProcessorApiKey = 'PLATIDELT5EA';
					this.venueService.ooVenue.ccProcessorApiSecret = '42ade27b2ab744209e29c396d8cd724c';
					break;
				}
				default: {
					break;
				}
			}
		}
	}

	onVenueChanges(event) {
		console.log(`component 2 change`);
		this.changesToSave = true;
		this.changesToSaveChange.emit(this.changesToSave);
	}
}
